export default __webpack_public_path__ + "static/media/icon_story_3.8eb0107c.svg";